import { ComponentProps, useRef } from 'react';
import { WW, useCalculateMessageRead } from '_utils';
import { QueryView } from 'Components';
import { Message } from 'types/message';
import useReadMessage from '../useReadMessage';

const useMarkMessageRead = (): Pick<ComponentProps<typeof QueryView>, 'viewabilityConfig'> & {
    onMessagesViewed: (viewableItems: Array<Message>) => void;
} => {
    const markRead = useReadMessage();
    const isRead = useCalculateMessageRead();

    const onMessagesViewed = useRef((viewableItems: Array<Message>) => {
        const messageIds = viewableItems.filter((msg: Message) => !isRead(msg)).map(({ id }) => id);

        if (messageIds.length) {
            markRead(messageIds, false);
        }
    }).current;

    const viewConfigRef = useRef({ viewAreaCoveragePercentThreshold: WW * 0.1 });

    return { onMessagesViewed, viewabilityConfig: viewConfigRef.current };
};

export default useMarkMessageRead;
